import { gql } from '@apollo/client';

export const GET_BALANCE = gql`
  query GetBalance {
    currentUserBalance {
      cash
      pack
      bonus
      total
      paidAds
    }
  }
`;
